const INITIAL_STATE = {
  errors: {},
  customer: {},
  customerList: {},
  addCustomer: {}
}

const customerList = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'GET_CUSTOMER_LIST_SUCCESSFULLY':
    return { ...state, ...INITIAL_STATE, customerList: action.data }
  case 'GET_CUSTOMER_LIST_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'GET_CUSTOMER_SUCCESSFULLY':
    return { ...state, ...INITIAL_STATE, customer: action.data }
  case 'GET_CUSTOMER_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'ADD_CUSTOMER_SUCCESSFULLY':
    return { ...state, ...INITIAL_STATE, addCustomer: action.data }
  case 'ADD_CUSTOMER_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};

export default customerList;
